import router from '../services/router_service';
import videosController from '../controllers/video_controller';

router.on('route:videos', videosController);
